<template>
  <Modal
    style="z-index: 4000"
    :top="top"
    :title="title"
    :visible.sync="innerShow"
    @onCancel="onCancel"
    @onConfirm="onConfirm">
    <div class="content">
      <t-form :data="formData" ref="form" labelWidth="0">
        <t-form-item name="name" :rules="rules">
          <t-input autofocus v-model="formData.name" :placeholder="$t('请输入内容')" />
        </t-form-item>
      </t-form>
    </div>
  </Modal>
</template>
<script>
import { computed, defineComponent, ref, watch, getCurrentInstance } from '@vue/composition-api';
import Modal from '@/renderer/components/mobile/base/Modal/index.vue';
import i18n, { i18n_t } from '@/locales/i18n';
export default defineComponent({
  name: 'EditModal',
  props: {
    top: {
      type: String,
      default: '50%',
    },
    show: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: i18n_t('标题'),
    },
    rules: {
      type: Array,
      default: () => [
        {
          required: true,
          message: i18n_t('请输入内容'),
        },
      ],
    },
  },
  components: {
    Modal,
  },
  setup(props, content) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const formData = ref({
      name: '',
    });
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        content.emit('update:show', val);
      },
    });
    const methods = {
      onCancel() {
        innerShow.value = false;
      },
      async onConfirm() {
        const result = await this.$refs.form.validate();
        if (result === true) {
          content.emit('onConfrim', formData.value.name.trim());
          innerShow.value = false;
        }
      },
    };
    watch(
      () => props.show,
      val => {
        if (val) {
          formData.value.name = '';
        }
      },
    );
    return {
      formData,
      innerShow,
      ...methods,
    };
  },
});
</script>
<style lang="scss" scoped>
::v-deep .t-input {
  height: 44px;
}
.content {
  padding: 32px 16px;
}
</style>
